import { Bounds } from "../engine/space/bounds";
import { RDisplay } from "../ui/RotDisplay";
import { gameData } from "./GameManager";
import { Item, ItemBreed } from "./items/Item";
import { Actor, ActorBreed } from "./actors/Actor";
import { Entity } from "../engine/entity/Entity";
import { ItemTypes } from "./items/itemsTypes";
import { ActionSpeed } from "./actions/Action";

class EntityManager {
  private id = 1;

  private getId() {
    const r = this.id;
    this.id += 1;
    return r;
  }

  resetIds() {
    this.id = 1;
  }

  addActorChildren(actor: Actor) {
    const breed = actor.breed;
    if (breed.defaultWielding) {
      if (breed.defaultWielding.left) {
        actor.wielding.left = this.createItem(
          ItemTypes[breed.defaultWielding.left as keyof typeof ItemTypes]
        );
        actor.wielding.left.everHeld = true;
        actor.wielding.left.applyStats(actor, true);
      }
      if (breed.defaultWielding.right) {
        actor.wielding.right = this.createItem(
          ItemTypes[breed.defaultWielding.right as keyof typeof ItemTypes]
        );
        actor.wielding.right.everHeld = true;
        actor.wielding.right.applyStats(actor, true);
      }
      if (breed.defaultWielding.mode) {
        actor.wielding.mode =
          breed.defaultWielding.mode || breed.defaultWielding.mode;
      }
    }

    if (breed.defaultWearing) {
      if (breed.defaultWearing.armor) {
        actor.wearing.armor = this.createItem(
          ItemTypes[breed.defaultWearing.armor as keyof typeof ItemTypes]
        );
        actor.wearing.armor.everHeld = true;
        actor.wearing.armor.applyStats(actor, true);
      }
    }
    breed.defaultContains &&
      breed.defaultContains.forEach(([type, quantity]) => {
        const containing = this.createItem(
          ItemTypes[type as keyof typeof ItemTypes]
        );
        containing.everHeld = true;
        actor.contains.add(containing.id, containing);
      });
  }

  createActor(breed: ActorBreed, x?: number, y?: number) {
    const newId = this.getId();
    const actor = new Actor(newId, breed, x, y);
    if (x != null || y != null) {
      gameData.actors.add(newId, actor);
    }

    this.addActorChildren(actor);

    return actor;
  }

  createItem(breed: ItemBreed, x?: number, y?: number) {
    const newId = this.getId();
    const actor = new Item(newId, breed, x, y);
    if (x != null || y != null) {
      gameData.items.add(newId, actor);
    }
    return actor;
  }

  drawEntities = (display: RDisplay, bounds: Bounds, view: Bounds) => {
    const result: Record<number, [Entity<any>, boolean]> = {};
    let existing, pos;

    gameData.items.forEach((item) => {
      if (
        item.x < view.x ||
        view.x + view.w <= item.x ||
        item.y < view.y ||
        view.y + view.h <= item.y
      ) {
        return;
      }
      pos = item.x + item.y * gameData.current.width;
      if (!gameData.seeAll && !gameData.fov.has(pos)) {
        return;
      }
      existing = result[pos];
      if (existing) {
        existing[1] = true;
        if (existing[0].breed.displayPriority < item.breed.displayPriority) {
          existing[0] = item;
        }
      } else {
        result[pos] = [item, false];
      }
    });

    gameData.actors.forEach((actor) => {
      if (
        actor.x < view.x ||
        view.x + view.w <= actor.x ||
        actor.y < view.y ||
        view.y + view.h <= actor.y
      ) {
        return;
      }
      pos = actor.x + actor.y * gameData.current.width;
      existing = result[pos];
      if (!gameData.seeAll && !gameData.fov.has(pos)) {
        return;
      }
      if (existing) {
        existing[1] = true;
        if (existing[0].breed.displayPriority < actor.breed.displayPriority) {
          existing[0] = actor;
        }
      } else {
        result[pos] = [actor, false];
      }
    });

    Object.values(result).forEach(([actor]) => {
      display.drawAppend(
        actor.x + bounds.x - view.x,
        actor.y + bounds.y - view.y,
        actor.breed.ch,
        actor.breed.fg,
        actor.breed.bg || "transparent"
      );
    });
  };

  actorPlan() {
    gameData.actors.forEach((a) => {
      const action = a.plan();
      if (action) {
        switch (action.speed) {
          case ActionSpeed.FAST:
            gameData.quickActionQueue.unshift(action);
            break;
          case ActionSpeed.MEDIUM:
            gameData.actionQueue.unshift(action);
            break;
          case ActionSpeed.SLOW:
            gameData.slowActionQueue.unshift(action);
            break;
        }
      }
    });
  }

  actorReplan(a: Actor) {
    const action = a.plan();
    if (action) {
      //This action always goes into slow so it's done this turn
      gameData.slowActionQueue.push(action);
    }
  }
}

export default new EntityManager();
